import { Component, Output, EventEmitter, Input } from '@angular/core';
import { AbstractFormComponent } from '@app/shared/common/abstract.component';
import { DropdownQuestion } from '@app/core/models/question/dropdown-question';
import { markFormGroupTouched } from '@app/core/utils';
import { QuestionBase } from '@app/core/models/question/question-base';

declare var $;

@Component({
  selector: 'app-coverage-new-policy',
  templateUrl: './new-policy.component.html'
})
export class NewPolicyComponent extends AbstractFormComponent {
  @Input() data: any;
  @Output() newPolicyAdded = new EventEmitter<any>();

  isShownMoreDetails = false;

  constructor() {
    super();
  }

  onShowMoreDetails() {
    this.isShownMoreDetails = true;
  }

  onSubmit() {
    this.form = this.data.form;
    super.onSubmit();

    if (this.submitted) {
      this.isShownMoreDetails = false;
      this.newPolicyAdded.emit({ form: this.form, insuranceKey: this.data.key });
    } else {
      markFormGroupTouched(this.form);
    }
  }

  onDropdownChanged(event) {
    this.data.questionaire.forEach((question: QuestionBase<string>) => {
      question.setDisplaying(event);
      if (question instanceof DropdownQuestion) {
        const isChanged = question.filterOptions(event);
        if (isChanged) {
          this.data.form.controls[question.key].setValue(question.options[0].key);
        }
      }
    });
  }

  handleNextQuestion(event) {
    const buffer = event.split('-');
    if ($(`#${buffer[0]}-${Number(buffer[1]) + 1}`).find('input')[0]) {
      $(`#${buffer[0]}-${Number(buffer[1]) + 1}`).find('input')[0].focus();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/features/coverage/new-policy/new-policy.component.ts